<div id="main-wrapper" class="ga-root">
<% if ( user ) { %>

  <div class="ga" data-id="ga">

    <!-- Scrolling page surface — each in-app state renders its screen here. -->
    <main class="ga__viewport">
      <section data-id="page-content" class="ga__content"></section>
    </main>

    <!-- Floating bottom tab bar (hidden on detail / sub-pages). -->
    <bottom-nav></bottom-nav>

    <!-- Floating menu button, top right — opens the drawer from any screen. -->
    <top-menu></top-menu>

    <!-- Slide-in "Menü" drawer. -->
    <menu-drawer></menu-drawer>

    <!-- Weather detail / 7-day forecast bottom sheet (opened from the home screen). -->
    <weather-sheet></weather-sheet>

  </div>

<% } %>
</div>
